const request = require('./request')

export function config(args) {
	return request.get(`/util/config`, args)
}